export const FETCH_CONTRACTS_REQUEST =
  'agentsPwa/Contracts/FETCH_CONTRACTS_REQUEST';
export const SHOULD_FETCH_CONTRACTS =
  'agentsPwa/Contracts/SHOULD_FETCH_CONTRACTS';
export const CONTRACT_HOUSE_FETCH_SUCCESS =
  'agentsPwa/Contracts/CONTRACT_HOUSE_FETCH_SUCCESS ';
export const CONTRACT_USER_FETCH_SUCCESS =
  'agentsPwa/Contracts/CONTRACT_USER_FETCH_SUCCESS ';
export const FETCH_RENT_FLOW_CONTRACTS =
  'agentsPwa/Contracts/FETCH_RENT_FLOW_CONTRACTS';
